export default "__VITE_ASSET__de836278__"